/**
 * @file ViewLiveBanner.js
 * @description Banner component displayed at the bottom of View Live portals,
 * providing informational text and desktop/mobile view toggle icons.
 */

import { getText } from '../../i18n';

function ViewLiveBanner({
    viewMode = 'desktop',
    onViewModeChange,
    fontSize = '24px',
}) {
    const bannerText = getText('msg_8e390f08b4db');

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                padding: '20px 40px',
                zIndex: 9999,
                boxSizing: 'border-box',
            }}
        >
            <div
                style={{
                    width: '100%',
                    height: '64px',
                    backgroundColor: '#9EE2E3',
                    border: '1px solid #17BDBF',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '0 24px',
                    boxSizing: 'border-box',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        minWidth: 0,
                        flex: 1,
                    }}
                >
                    <i
                        className="bi bi-info-circle"
                        style={{
                            fontSize: '20px',
                            color: '#045F60',
                            flexShrink: 0,
                            position: 'relative',
                            top: '2px',
                        }}
                    />
                    <span
                        style={{
                            fontSize,
                            color: '#045F60',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {bannerText}
                    </span>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            flexShrink: 0,
                            marginLeft: '10px',
                        }}
                    >
                        <div
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                backgroundColor:
                                    viewMode === 'desktop'
                                        ? '#2F2B43'
                                        : 'transparent',
                                border:
                                    viewMode === 'desktop'
                                        ? '1px solid #2F2B43'
                                        : '1px solid #2F2B43',
                            }}
                            onClick={() => onViewModeChange('desktop')}
                        >
                            <i
                                className="bi bi-display"
                                style={{
                                    fontSize: '21px',
                                    lineHeight: '1',
                                    textAlign: 'center',
                                    color:
                                        viewMode === 'desktop'
                                            ? '#9EE2E3'
                                            : '#2F2B43',
                                }}
                            />
                        </div>

                        <div
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                backgroundColor:
                                    viewMode === 'mobile'
                                        ? '#2F2B43'
                                        : 'transparent',
                                border:
                                    viewMode === 'mobile'
                                        ? '1px solid #2F2B43'
                                        : '1px solid #2F2B43',
                            }}
                            onClick={() => onViewModeChange('mobile')}
                        >
                            <i
                                className="bi bi-phone"
                                style={{
                                    fontSize: '21px',
                                    lineHeight: '1',
                                    textAlign: 'center',
                                    color:
                                        viewMode === 'mobile'
                                            ? '#9EE2E3'
                                            : '#2F2B43',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewLiveBanner;
